/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from "@material-ui/core/styles/index";

import { Divider, Typography } from '@material-ui/core';

const styles = theme => ({
  logoImg: {
    filter: 'grayscale(100%)',
    opacity: 0.5
  }
});

class QuestionPageFooter extends PureComponent {

  render() {
    const {classes} = this.props;
    return (
        <>
          {false && <Divider style={{marginTop: '0.2rem', marginBottom: '0.5rem'}}/>}
          <div style={{paddingTop: 10, textAlign: 'center', paddingBottom: 5, marginBottom: -20}}><img src="https://www.kilpailu.fi/img/logos/DNA_logo.svg" width={35}
                    style={{marginRight: 15, marginBottom: 0, opacity: 0.3}}
                    alt="" className={classes.logoImg}/>
            <img
                src="https://www.kilpailu.fi/img/logos/AIG_logo.png"
                alt="" width={60} style={{marginRight: 15, marginBottom: 0}} className={classes.logoImg}/>
            {false && <img src="https://www.kilpailu.fi/img/logos/Elisa_logo_blue_RGB.png" width={70}
                 alt="" style={{marginRight: 10, marginBottom: -11}} className={classes.logoImg}/>}
            <img src="https://www.kilpailu.fi/img/logos/vattenfall.png" style={{marginBottom: -9}}
                 alt="" width={100} className={classes.logoImg}/></div>
          {false && <Typography variant="overline" gutterBottom align="center" color="textSecondary">
            Kilpailu.fi - Suomen parhaat kilpailut - Ehdot
          </Typography>}
        </>
    )
  }
}

export default withStyles(styles)(QuestionPageFooter);
